// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__ts32T","col":"styles_col__3YeSb"};